import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOutOfApp } from '../../lib/api/sign-out';

/**
 * `/logout`: runs the same sign-out as "Sign Out" in the profile menu, then
 * shows the login page. A link or bookmark to `/logout` used to land on the
 * not-found page and leave the session signed in.
 */
const LogoutRoute = () => {
  const navigate = useNavigate();
  // Sign out once, also when React runs the effect twice in development.
  const signedOut = useRef(false);

  useEffect(() => {
    if (signedOut.current) return;
    signedOut.current = true;
    const next = signOutOfApp();
    if (next) {
      navigate(next, { replace: true });
    }
  }, [navigate]);

  return null;
};

export default LogoutRoute;
